import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { selectV2Theme } from "../selectV2Theme";
export var Actions = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: inline-flex;\n    flex-direction: row-reverse;\n    align-items: center;\n    gap: ", ";\n\n    // For use in the SelectBasic component, we'll set this property.\n    align-self: start;\n\n    > button:last-child {\n        margin-left: -1px;\n    }\n\n    ", "\n"])), function (_ref) {
  var themeMode = _ref.themeMode;
  return selectV2Theme.actionButtons.gap(themeMode);
}, function (_ref2) {
  var isReadonly = _ref2.isReadonly,
    themeMode = _ref2.themeMode;
  return isReadonly ? "" : "\n                margin: ".concat(selectV2Theme.actionButtons.margin.top(themeMode), " ").concat(selectV2Theme.actionButtons.margin.top(themeMode), " auto 0;\n            ");
});
//# sourceMappingURL=Actions.js.map